import { render } from "./MenuDrawer.vue?vue&type=template&id=b8b3aba8&scoped=true"
import script from "./MenuDrawer.vue?vue&type=script&lang=js"
export * from "./MenuDrawer.vue?vue&type=script&lang=js"

import "./MenuDrawer.vue?vue&type=style&index=0&id=b8b3aba8&scoped=true&lang=css"
import "./MenuDrawer.vue?vue&type=style&index=1&id=b8b3aba8&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b3aba8"]])

export default __exports__